export const DEFAULT_ICON_PROPS = {
    color: 'var(--control-secondary-blur-color)',
    size: 24,
};

export const ICONS_GAP = 4;

export const CHECKOUT_MORE_LINK = 'https://yandex.ru/support/search/ru/quick-purchase';
